export default __webpack_public_path__ + "static/image 54-b6f91f97d09fe75f1d0913a869f58b3f.png";